import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Switch,
  Tooltip,
} from "@mui/material";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../assets/icons/close.png";
import axios from "axios";
import { toast } from "react-toastify";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Restaurant } from "../../SubscriptionSetup/types";

function EditDeliveryDialog(props) {
  const { open, onClose, foodItems } = props;
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [isDeliverableCheck, setIsDeliverableCheck] = useState([]);
  const [isCollectionCheck, setIsCollectionCheck] = useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;

  console.log("debug-foodItems", foodItems);
  // useEffect(() => {
  //   if (foodItems && foodItems.length > 0) {
  //     setIsDeliverableCheck(
  //       foodItems.map((item) =>
  //         item.menuTypeName === "Delivery" ? true :
  //           (item.restaurantIsDelivery && item.menuTypeName.includes("Delivery") ? Boolean(item.isDelivery) : false)
  //       )
  //     );

  //     setIsCollectionCheck(
  //       foodItems.map((item) =>
  //         item.menuTypeName === "Delivery" ? true : // Always true if "Delivery"
  //           (item.restaurantIsDelivery && item.menuTypeName.includes("Delivery") ? Boolean(item.restaurantIsCollectionOnly) : false)
  //       )
  //     );
  //   }
  // }, [foodItems]);

  useEffect(() => {
    if (foodItems && foodItems.length > 0) {
      setIsDeliverableCheck(
        foodItems.map((item) => (item.isDelivery == true ? true : false)),
      );

      setIsCollectionCheck(
        foodItems.map((item) => (item.isCollectionOnly == true ? true : false)),
      );
      // setIsCollectionCheck(
      //   foodItems.map((item) =>
      //     item.menuTypeName === "Delivery"
      //       ? true
      //       : item.restaurantIsDelivery && item.menuTypeName.includes("Delivery")
      //         ? item.restaurantIsCollectionOnly
      //           ? true // Force true
      //           : item.isCollectionOnly === "True" || item.isCollectionOnly === true
      //         : false
      //   )
      // );
    }
  }, [foodItems]);

  const handleDeliverableCheck = (index: number) => {
    setIsDeliverableCheck((prev: boolean[]) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleCollectionCheck = (index) => {
    setIsCollectionCheck((prev: boolean[]) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleUpdate = async () => {
    try {
      const updatePromises = foodItems.map((item, index) => {
        const url = `${apiAddress}/api/FoodItems/UpdateIsDelivery?foodItemId=${item.id}`;
        const payload = {
          foodItemId: item.id,
          isDelivery: isDeliverableCheck[index],
          isCollectionOnly: isCollectionCheck[index],
        };

        return axios.put(url, payload);
      });

      const results = await Promise.allSettled(updatePromises);
      const failedUpdates = results.filter((res) => res.status === "rejected");

      if (failedUpdates.length > 0) {
        toast.error(
          "Some delivery statuses failed to update. Please try again.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          },
        );
      } else {
        toast.success("Successfully Saved!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        props.onHandleAddItem(false);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog fullWidth={true} maxWidth={"md"} open={open} onClose={handleClose}>
      <SweetAlertModal
        headerText="Do you want to leave without saving?"
        bodyText="All changes made will be lost"
        open={openMenuCloseConfirmaitonModal}
        onyes={() => {
          setopenMenuCloseConfirmaitonModal(false);
          handleClose();
        }}
        close={() => setopenMenuCloseConfirmaitonModal(false)}
      />

      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <span style={{ color: "#2a7fd4" }}>GoTaste - Edit Delivery</span>
          <Grid item xs={6}>
            <DialogActions>
              <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <Grid container spacing={2} sx={{ padding: "0.5rem" }}>
          <Grid
            container
            sx={{ marginTop: "2rem", alignItems: "center", marginLeft: "2rem" }}
          >
            {foodItems.map((item, index) => (
              <Grid item xs={12} key={item.id} sx={{ paddingBottom: "1rem" }}>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ paddingBottom: "1rem" }}
                >
                  <Grid item xs={12}>
                    <Typography fontSize={16}>{item.title}</Typography>
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    sx={{
                      paddingTop: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginLeft: "2rem",
                    }}
                  >
                    <Typography fontSize={16}>Is Deliverable</Typography>
                    <span>
                      <Switch
                        checked={isDeliverableCheck[index] ?? false}
                        onChange={() => handleDeliverableCheck(index)}
                        inputProps={{ "aria-label": "controlled" }}
                        size="small"
                        //disabled={item.menuTypeName === "Delivery" || !item.restaurantIsDelivery || !item.menuTypeName.includes("Delivery")}
                        disabled={
                          item.menuTypeName === "Delivery" ||
                          !item.restaurantIsDelivery ||
                          item.restaurantIsCollectionOnly ||
                          item.isCollectionOnly
                        }
                      />
                    </span>
                  </Grid>
                </Grid>

                {isDeliverableCheck[index] &&
                  item.restaurantIsDelivery &&
                  item.menuTypeName.includes("Delivery") && (
                    <Grid
                      container
                      alignItems="center"
                      sx={{ paddingLeft: "2rem", marginLeft: "2rem" }}
                    >
                      <Grid
                        item
                        xs={4}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <Typography fontSize={16}>Collection Only</Typography>
                        {/* <Tooltip
                        title={item.restaurantIsCollectionOnly ? "Restaurant is collection only." : ""}
                        arrow
                      > */}
                        <span>
                          <Switch
                            checked={isCollectionCheck[index] ?? false}
                            onChange={() => handleCollectionCheck(index)}
                            inputProps={{ "aria-label": "controlled" }}
                            size="small"
                            // disabled={
                            //   item.menuTypeName === "Delivery" ||
                            //   item.restaurantIsCollectionOnly // Disable if restaurant is collection-only
                            // }
                            disabled={
                              item.restaurantIsCollectionOnly ||
                              item.isCollectionOnly
                            }
                          />
                        </span>

                        {/* </Tooltip> */}
                      </Grid>
                    </Grid>
                  )}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => setopenMenuCloseConfirmaitonModal(true)}
          color="primary"
        >
          Close
        </Button>
        <Button color="primary" onClick={handleUpdate}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditDeliveryDialog;
